import { auth } from 'src/app/firebase';
import { Configuration } from '../openapi';
import globalAxios from 'axios';
import { useNavigate } from 'react-router-dom';
import { environment } from 'src/environment/environment';

globalAxios.interceptors.request.use(async (request) => {
  // @ts-ignore
  if (!request.skipAuth) {
    request.headers.Authorization = `Bearer ${await auth.currentUser?.getIdToken()}`;
  }
  return request;
});

globalAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      console.error('Response error :: ', error.response);
      try {
        const token = auth.currentUser?.getIdToken();
        return Promise.resolve(token);
      } catch (refreshError) {
        const navigate = useNavigate();
        navigate('/login');
        return await Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export const config = new Configuration({
  basePath: environment.backendDomain,
});
